import { find, register } from '../../../Javascript/Utils'

const component = el => {
  const componentPrefix = el.dataset.componentprefix
  const close = find(`.${componentPrefix}close`, el)
  close.addEventListener('click', function (e) {
    el.style.display = 'none'
  })

  window.addEventListener('click', function (event) {
    if (event.target === el) {
      el.style.display = 'none'
    }
  })

  const msieversion = el => {
    const ua = window.navigator.userAgent
    const msie = ua.indexOf('MSIE ')
    const trident = ua.indexOf('Trident/')
    if (msie > 0 || trident > 0) {
      el.classList.add(`${componentPrefix}fadeIn`)
    }
    return false
  }
  msieversion(el)
}

register('modal', component)
